<template>
	<div class="pageBottom">
		<div class="copy-right">
			<div>Copyright © 2019 版权所有备案号：皖ICP备2021012101号</div>
		</div>
	</div>
</template>
<script>
export default {
    name:"Footer",
    data(){
        return {
            tabNum:0,
            tabList:['首页','关于我们','成功案例','新闻动态','联系我们']
        }
    },
    methods:{
        tabFn(index){
            this.tabNum=index
        }
    }
}
</script>
<style scoped>
.pageBottom {
  position: relative;
  background-color: #0b1531;
}

.copy-right {
	height: 80px;
	line-height: 80px;
	background: #121416;
	text-align: center;
	font-size: 12px;
	color: #ffffff99;
	font-weight: 300;
  font-family: PingFangSC-Light,PingFang SC;
}

.pageBottom .mains {
	width: 1200px;
	margin: 0 auto;
	padding: 30px 0;
	display: flex;
	justify-content: space-between;
	align-items: center;
	box-sizing: border-box;
}

.pageBottom .mains .left {
  color: #6b7799;
  font-size: 14px;
  line-height: 30px;
}

.pageBottom .mains .right img {
  width: 120px;
}
</style>


// WEBPACK FOOTER //
// src/components/footer/index.vue